'use client';

import React from 'react';
import { useLanguage } from '@/contexts/language-context';

interface ChartContainerProps {
  children: React.ReactNode;
}

/**
 * Shared wrapper for all chart components.
 * Provides consistent outer spacing and the chart disclaimer.
 */
export function ChartContainer({ children }: ChartContainerProps) {
  const { t } = useLanguage();

  return (
    <div className="mx-auto my-3 w-full max-w-full sm:my-6 sm:w-[90%]">
      {children}
      <div className="mt-2 text-xs text-gray-400 italic">
        {t('chart.disclaimer')}
      </div>
    </div>
  );
}
